import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook to handle push notification click navigation from service worker
 */
export function usePushNotificationHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'NOTIFICATION_CLICK' && event.data?.actionUrl) {
        const actionUrl = event.data.actionUrl;
        
        // Navigate to the action URL
        if (actionUrl.startsWith('/')) {
          navigate(actionUrl);
        } else if (actionUrl.startsWith('http')) {
          window.location.href = actionUrl;
        }
      }
    };

    // Listen for messages from service worker
    navigator.serviceWorker?.addEventListener('message', handleMessage);

    return () => {
      navigator.serviceWorker?.removeEventListener('message', handleMessage);
    };
  }, [navigate]);
}
